import React, { useEffect } from 'react';
import { enableProtection, detectDevTools, preventDataExtraction } from '../utils/security';
import { SECURITY_CONFIG } from '../utils/env';

/**
 * Security Wrapper Component
 * Applies security measures to prevent data extraction and unauthorized access
 */
const SecurityWrapper = ({ children }) => {
  useEffect(() => {
    if (SECURITY_CONFIG.ENABLE_PROTECTION) {
      // Enable protection on mount
      enableProtection();
      
      if (SECURITY_CONFIG.ENABLE_DEVTOOLS_DETECTION) {
        detectDevTools();
      }
      
      preventDataExtraction();
    }

    // Prevent common download methods
    const preventDownload = (e) => {
      // Prevent Ctrl+S (Save Page)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        return false;
      }
      // Prevent Ctrl+P (Print - can be used to save as PDF)
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('keydown', preventDownload);

    // Disable image dragging
    const preventImageDrag = (e) => {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'SVG') {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('dragstart', preventImageDrag);
    document.addEventListener('selectstart', (e) => {
      // Allow text selection for inputs and textareas
      if (e.target.tagName !== 'INPUT' && 
          e.target.tagName !== 'TEXTAREA' && 
          !e.target.isContentEditable) {
        e.preventDefault();
        return false;
      }
    });

    return () => {
      document.removeEventListener('keydown', preventDownload);
      document.removeEventListener('dragstart', preventImageDrag);
    };
  }, []);

  return <>{children}</>;
};

export default SecurityWrapper;

